<p-toast position="top-center" key="tc" />
<p-confirmdialog />

<div *ngIf="loading; else pageDiv" class="me-3 mt-3">
  <div class="d-flex align-items-center">
    <strong>Caricamento...</strong>
    <p-progress-spinner class="ms-auto" aria-label="Caricamento" [style]="{ width: '5rem', height: '5rem' }" />
  </div>
</div>

<ng-template #pageDiv>
  <p-table [value]="users"
           [paginator]="true"
           [rows]="25"
           [globalFilterFields]="['userId', 'name', 'familyName', 'userName']"
           stripedRows
           #dt>

    <ng-template #caption>
      <div class="flex items-center justify-between">
        <span class="text-xl font-bold">Elenco Utenti</span>
        <div class=" inline-flex gap-2">

          <div class="flex">
            <input pInputText type="text" (input)="dt.filterGlobal($any($event.target).value, 'contains')" placeholder="Cerca..." />
          </div>
          <p-button icon="fas fa-plus" rounded raised (click)="onShowDialog(newItem)"
                    pTooltip="Aggiungi utente" tooltipPosition="bottom" />
        </div>
      </div>
    </ng-template>

    <ng-template pTemplate="header">
      <tr>
        <th>ID</th>
        <th>Nome</th>
        <th>Cognome</th>
        <th>E-Mail</th>
        <th>Stato</th>
        <th style="width:10%"></th>
        <th style="width:10%"></th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-user>
      <tr [pSelectableRow]="user">
        <td>{{ user.userId }}</td>
        <td>{{ user.name }}</td>
        <td>{{ user.familyName }}</td>
        <td>{{ user.userName }}</td>
        <td>{{ user.isActive ? 'Attivo' : 'Disattivato' }}</td>
        <td>
          <p-button variant="outlined" icon="far fa-trash-can" (click)="onDelete($event, user)" />
        </td>
        <td>
          <p-button icon="fas fa-user-pen" (click)="onShowDialog(user)" />
        </td>
      </tr>
    </ng-template>
  </p-table>
</ng-template>

<p-dialog header="Header"
          [(visible)]="showDialog"
          [modal]="true"
          [closable]="false"
          [draggable]="false"
          [resizable]="false">
  <ng-template pTemplate="header">
    <div class="grid w-full grid-cols-3 items-center gap-3 p-4">
      <label for="userId" class="text-left font-semibold">ID</label>
      <input pInputText id="userId" class="col-span-2" [disabled]="true" [(ngModel)]="selectedItem.userId" />

      <label for="email" class="text-left font-semibold">UserName/E-Mail</label>
      <input pInputText id="email" class="col-span-2" type="email" [disabled]="!isNew" [(ngModel)]="selectedItem.userName" />
    </div>
  </ng-template>
  <p-tabs [(value)]="tabId">
    <p-tablist>
      <p-tab [value]="0">Generale</p-tab>
      <p-tab [value]="1">Ruolo</p-tab>
      <p-tab [value]="2">Organizzazioni</p-tab>
    </p-tablist>
    <p-tabpanels>
      <p-tabpanel [value]="0">
        <div class="grid grid-cols-3 items-center gap-3">
          <label for="name" class="text-left font-semibold">Nome</label>
          <input pInputText id="name" class="col-span-2" autocomplete="off" [(ngModel)]="selectedItem.name" />

          <label for="surname" class="text-left font-semibold">Cognome</label>
          <input pInputText id="surname" class="col-span-2" autocomplete="off" [(ngModel)]="selectedItem.familyName" />

          <label for="mass" class="text-left font-semibold">Peso</label>
          <p-inputnumber inputId="mass" [(ngModel)]="selectedItem.mass" mode="decimal" [minFractionDigits]="1" [maxFractionDigits]="3" />
          <label class="text-left font-semibold">Kg</label>

          <div class="border-round shadow-1 col-span-3 flex items-center justify-between p-3">
            <div class="flex items-center gap-3">
              <p-toggleswitch [(ngModel)]="selectedItem.isActive"></p-toggleswitch>
              <span [ngClass]="{
            'text-green-600 font-semibold': selectedItem.isActive,
            'text-red-500 font-semibold': !selectedItem.isActive
          }">
                {{ selectedItem.isActive ? 'Attivato' : 'Disattivato' }}
              </span>
            </div>
            <i class="far"
               [ngClass]="selectedItem.isActive ? 'fa-circle-check text-green-500' : 'fa-circle-xmark text-red-400'"
               style="font-size: 1.4rem;"></i>
          </div>
        </div>
        <hr />
        <div class="flex flex-row justify-end gap-3 py-3">
          <p-button label="Reset Password" variant="outlined" [disabled]="isNew" (click)="onResetPassword($event)" />
        </div>
        <hr />
      </p-tabpanel>

      <p-tabpanel [value]="1">
        <p-listbox [(ngModel)]="selectedRole" [options]="roles" optionLabel="description" [checkmark]="true" />
      </p-tabpanel>

      <p-tabpanel [value]="2">
        <p-table [value]="selectedItem.organizations"
                 dataKey="organizationId"
                 stripedRows
                 [expandedRowKeys]="expandedRows">
          <ng-template #caption *ngIf="isSuperAdmin">
            <div class="flex items-center justify-between">
              <span class="font-bold">Organizzazioni</span>
              <p-button icon="fas fa-pencil" [text]="true" (click)="onAddOrgs()" />
            </div>
          </ng-template>
          <ng-template #body let-organization let-expanded="expanded">
            <tr>
              <td style="width:5rem">
                <p-button type="button" pRipple [pRowToggler]="organization" [text]="true" [rounded]="true" [plain]="true" [icon]="expanded ? 'fas fa-chevron-down' : 'fas fa-chevron-right'" />
              </td>
              <td>{{ organization.name }}</td>
              <!--<td>{{ isValid(organization.authorizedDate) ? ( organization.authorizedDate | date:'mediumDate') : '---' }}</td>-->
            </tr>
          </ng-template>
          <ng-template #expandedrow let-organization>
            <tr>
              <td colspan="7">
                <p-table [value]="organization.teams" dataKey="teamId" size="small">
                  <ng-template #header>
                    <tr>
                      <th>Squadra</th>
                      <th style="width:3rem">
                        <p-button icon="fas fa-pencil" [text]="true" (click)="onAddTeam(organization)" />
                      </th>
                    </tr>
                  </ng-template>
                  <ng-template #body let-team>
                    <tr>
                      <td>{{ team.name }}</td>
                      <td></td>
                    </tr>
                  </ng-template>
                  <ng-template #emptymessage>
                    <tr>
                      <td colspan="6">There are no team for this organization yet.</td>
                    </tr>
                  </ng-template>
                </p-table>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </p-tabpanel>
    </p-tabpanels>
  </p-tabs>

  <ng-template pTemplate="footer">
    <p-button label="Annulla"
              [text]="true"
              severity="secondary"
              variant="outlined"
              (click)="onCloseDialog()" />
    <p-button label="Salva"
              [disabled]="selectedItem.organizations.length === 0 || selectedRole.id === 0"
              (click)="onSave()" />
  </ng-template>
</p-dialog>

<p-dialog header="Seleziona le Organizzazioni"
          [(visible)]="showOrganization"
          [modal]="true"
          [closable]="false"
          [draggable]="false"
          [resizable]="false">

  <p-listbox [(ngModel)]="selectedOrganizations" [options]="organizations" [multiple]="true" [checkbox]="true" optionLabel="name" />

  <ng-template pTemplate="footer">
    <p-button label="Annulla"
              severity="secondary"
              variant="outlined"
              (click)="showOrganization = false" />
    <p-button label="Conferma"
              (click)="onUpdateOrganizations()" />
  </ng-template>
</p-dialog>

<p-dialog header="Seleziona le Squadre"
          [(visible)]="showTeam"
          [modal]="true"
          [closable]="false"
          [draggable]="false"
          [resizable]="false">

  <p-listbox [(ngModel)]="selectedTeams" [options]="teams" [multiple]="true" [checkbox]="true" optionLabel="name" />

  <ng-template pTemplate="footer">
    <p-button label="Annulla"
              severity="secondary"
              variant="outlined"
              (click)="showTeam = false" />
    <p-button label="Conferma"
              (click)="onUpdateTeams()" />
  </ng-template>
</p-dialog>
